import api from './api';

export const getPartners = (cityId) => api.get('/api/partners', { params: { cityId } });
export const getOffers = (partnerId) => partnerId ? api.get(`/api/partners/${partnerId}/offers`) : api.get('/api/partners/offers');
export const redeemOffer = (offerId) => api.post(`/api/partners/offers/${offerId}/redeem`);
export const cancelRedemption = (redemptionId) => api.post(`/api/partners/redemptions/${redemptionId}/cancel`);
export const validateQR = (qrToken) => api.post('/api/partners/validate-qr', { qrToken });
export const getMyRedemptions = () => api.get('/api/partners/my-redemptions');
